// Duitse teksten van de to-do's in de ouderapp (zie todoApp.nl.ts).
export const appTodoDe = {
    tab: 'To-dos',
    repeatOption: 'Ohne Datum (To-do)',
    repeatHint: 'Kein Datum, keine Uhrzeit. Das To-do bleibt, bis es erledigt ist.',
    description: 'Beschreibung (optional)',
    dueDate: 'Bis spätestens (optional)',
    dueClear: 'Kein Enddatum',
    from: 'von {name}',
    due: 'bis spätestens {date}',
    emptyTitle: 'Keine To-dos',
    emptyBody: 'Ein To-do hat kein Datum und keine Uhrzeit und bleibt, bis es erledigt ist. Zum Beispiel: den Schuhschrank streichen.',
    add: 'To-do hinzufügen',
    doneSection: 'Erledigt',
    doneOn: 'erledigt am {date}',
    newTitle: 'Neues To-do',
    editTitle: 'To-do bearbeiten',
    important: 'Wichtig',
    importantHint: 'Steht oben, mit einem kleinen Zeichen.',
    assign: 'Zuweisen an',
    assignHint: 'Babys und Kleinkinder bekommen keine To-dos.',
    assigned: 'Zugewiesen an {names}',
    // Oprichter 6 okt: privé to-do's in Mijn omgeving en de kaart op Vandaag.
    privateNote: 'Nur du siehst diese To-dos. Nicht die Familie, nicht die Tafel. Auf die Tafel kommt nur etwas, wenn du das selbst ausdrücklich für ein Tablet bestätigst; das kannst du jederzeit wieder wegnehmen.',
    privateEntry: 'Ein privates To-do? Lege es in Mein Bereich an. Dort siehst nur du es.',
    privateEntryButton: 'Zu Mein Bereich',
    gateTitle: 'Deine eigenen To-dos',
    gateBody: 'Deine eigenen To-dos stehen in Mein Bereich. Nur du siehst sie: nicht die Familie, nicht die Tafel. Auf die Tafel kommt nur etwas, wenn du das selbst ausdrücklich für ein Tablet bestätigst; das kannst du jederzeit wieder wegnehmen.',
    gateOpen: 'Mein Bereich öffnen',
    gateOpening: 'Wird geöffnet…',
    widgetEmpty: 'Keine offenen To-dos.',
    widgetAll: 'Alle To-dos',
    widgetMore: '+{count} weitere',
    widgetFrom: 'Von {name}, nur lesen',
    widgetOpenIn: 'In {name} öffnen',
    widgetPending: 'Wartet auf Freigabe',
};
//# sourceMappingURL=todoApp.de.js.map